import { useState, useEffect } from 'react';
import { List } from 'lucide-react';

const TableOfContents = ({ items = [] }) => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-100px 0px -66% 0px' }
    );

    items.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, [items]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <div className="toc-sticky" data-testid="table-of-contents">
      <div className="bg-slate-50 border border-slate-200 rounded-sm p-4">
        <h4 className="font-heading font-bold text-sm text-navy-900 mb-4 flex items-center gap-2">
          <List className="w-4 h-4" />
          Inhaltsverzeichnis
        </h4>
        <nav>
          <ul className="space-y-1">
            {items.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className={`toc-link w-full text-left ${
                    activeId === item.id ? 'active' : ''
                  } ${item.level === 3 ? 'pl-6' : ''}`}
                >
                  {item.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default TableOfContents;
